// src/pages/batches/EditBatch.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import API_BASE_URL from '../../utils/config';

export default function EditBatch() {
  const { id } = useParams();
  const [form, setForm] = useState({
    product_id: '',
    batch_number: '',
    expiry_date: '',
    quantity: '',
    mrp: ''
  });
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const fetchBatch = async () => {
      const res = await axios.get(`${API_BASE_URL}/api/batches/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setForm(res.data);
    };
    const fetchProducts = async () => {
      const res = await axios.get(`${API_BASE_URL}/api/products`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProducts(res.data);
    };
    fetchBatch();
    fetchProducts();
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    await axios.put(`${API_BASE_URL}/api/batches/${id}`, form, {
      headers: { Authorization: `Bearer ${token}` },
    });
    navigate('/batches');
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Edit Batch</h2>
      <form onSubmit={handleSubmit} className="space-y-4 bg-white p-6 rounded shadow">
        <select name="product_id" value={form.product_id} onChange={handleChange} className="w-full border p-2 rounded">
          <option value="">Select Product</option>
          {products.map((p) => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
        </select>
        <input name="batch_number" value={form.batch_number} onChange={handleChange} className="w-full border p-2 rounded" />
        <input type="date" name="expiry_date" value={form.expiry_date} onChange={handleChange} className="w-full border p-2 rounded" />
        <input type="number" name="quantity" value={form.quantity} onChange={handleChange} className="w-full border p-2 rounded" />
        <input type="number" name="mrp" value={form.mrp} onChange={handleChange} className="w-full border p-2 rounded" />
        <button className="bg-blue-600 text-white px-4 py-2 rounded">Update</button>
      </form>
    </div>
  );
}
